import { Button, FormInput, Modal, formatDateWithTime } from '@ami/react/core';
import moment from 'moment';
import React from 'react';
import InputMask from 'react-input-mask';
import AuthorizedListDealerGroupSettings from '../../dealer-users/components/authorization/AuthorizedListDealerGroupSettings';

const ResendInvitationConfirmationModal = ({
  show,
  onShowUpdated,
  onConfirm,
  dealerUserEmail
}) => (
  <Modal
    title="Send Invitation"
    show={show}
    onShowUpdated={onShowUpdated}
    okTitle="Yes"
    cancelTitle="No"
    onOk={onConfirm}
    showCancel={true}
  >
    <div>
      If you re-send the invitation, the previous invitation email will no longer be valid.
      Are you sure you want to re-send a new invitation to the e-mail <span className="fw-bold">{dealerUserEmail}</span>?
    </div>
  </Modal>
);

const SendInvitationConfirmationModal = ({
  show,
  onShowUpdated,
  onConfirm,
  dealerUserEmail
}) => (
  <Modal
    title="Send Invitation"
    show={show}
    onShowUpdated={onShowUpdated}
    okTitle="Yes"
    cancelTitle="No"
    onOk={onConfirm}
    showCancel={true}
  >
    <div>
      Are you sure you want to send an invitation to the e-email <span className="fw-bold">{dealerUserEmail}</span>
    </div>
  </Modal>
);

export default class DealerUserEditFormData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showResendInvitationModal: false,
      showInvitationModal: false,
      dealerUserEmail: props.dealerUser.email
    };
    this.updateDealerUser = this.updateDealerUser.bind(this);
    this.handledAuthorizedDealerGroupsChanged =
      this.handledAuthorizedDealerGroupsChanged.bind(this);
  }

  updateDealerUser = (e) =>
    this.props.dealerUserChanged({
      ...this.props.dealerUser,
      [e.target.id]: e.target.value,
    });

  onSendInvitationEmail = () => {
    const { dealerUser } = this.props;
    if (dealerUser.invitedDate && moment().diff(moment(dealerUser.invitedDate), 'hours') < 72) {
      this.setState({ showResendInvitationModal: true });
    } else {
      this.setState({ showInvitationModal: true });
    }
  };

  handledAuthorizedDealerGroupsChanged(authorizedDealerGroups) {
    const { dealerUserChanged, dealerUser } = this.props;
    dealerUserChanged({ ...dealerUser, authorizedDealerGroups });
  }

  render() {
    const {
      dealerUser,
      permissions,
      availableEmailTemplateTypes,
      openChangePasswordModal,
      sendingInvitation,
      sendInvitationEmail,
      enabledAddDealerGroup,
      enabledRemoveDealerGroup,
    } = this.props;

    return (
      <div>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormInput
              id="fullName"
              label="Name"
              value={dealerUser.fullName}
              onChange={this.updateDealerUser}
              required
            />
          </div>
          {!dealerUser.isRegistered && (
            <div className="col-12 col-md-3 form-group">
              <label className="form-label">Registration</label>
              <div>
                <Button
                  type="button"
                  className="btn-primary"
                  label={sendingInvitation ? 'Sending' : 'Send Invitation'}
                  onClick={() => this.onSendInvitationEmail()}
                  showSpinner={sendingInvitation}
                  iconName="paper-plane"
                />
                {dealerUser.invitedDate && (
                  <div className="mt-1">
                    <small>
                      <em>
                        Invitation sent on{' '}
                        <span>
                          {formatDateWithTime(dealerUser.invitedDate)}
                        </span>
                      </em>
                    </small>
                  </div>
                )}
              </div>
            </div>
          )}
          {dealerUser.isRegistered && (
            <div className="col-12 col-md-3 form-group">
              <label className="form-label">Password</label>
              <div>
                <Button
                  type="button"
                  className="btn-danger"
                  label="Reset Password"
                  onClick={() => openChangePasswordModal()}
                />
              </div>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <FormInput
              id="email"
              type="email"
              label="Email"
              value={dealerUser.email}
              onChange={this.updateDealerUser}
              required
            />
          </div>
          <div className="col-12 col-md-6">
            <InputMask
              mask="(999) 999-9999"
              maskChar=" "
              value={dealerUser.phoneNumber}
              onChange={this.updateDealerUser}
            >
              {() => (
                <FormInput id="phoneNumber" type="tel" label="Phone Number" />
              )}
            </InputMask>
          </div>
        </div>
        <AuthorizedListDealerGroupSettings
          dealerUser={dealerUser}
          permissions={permissions}
          availableEmailTemplateTypes={availableEmailTemplateTypes}
          onAuthorizedDealerGroupsChanged={
            this.handledAuthorizedDealerGroupsChanged
          }
          enabledAdd={enabledAddDealerGroup}
          enabledRemove={enabledRemoveDealerGroup}
        />
        <ResendInvitationConfirmationModal
          show={this.state.showResendInvitationModal}
          onShowUpdated={(show) => {
            if (!show) this.setState({ showResendInvitationModal: false });
          }}
          onConfirm={sendInvitationEmail}
          dealerUserEmail={this.state.dealerUserEmail}
        />
        <SendInvitationConfirmationModal
          show={this.state.showInvitationModal}
          onShowUpdated={(show) => {
            if (!show) this.setState({ showInvitationModal: false });
          }}
          onConfirm={sendInvitationEmail}
          dealerUserEmail={this.state.dealerUserEmail}
        />
      </div>
    );
  }
}
